<template>
    <v-dialog v-model="moveDialog" persistent max-width="450">
        <v-card style="border-radius: 8px">
            <v-card-text class="px-4">
                <v-row class="my-0">
                    <v-col cols="12" md="12" class="d-flex justify-end pb-0 my-0 pt-4">
                        <v-btn icon dark x-small @click="moveDialog = false">
                            <v-icon size="20" color="#37323c">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="12" class="d-flex justify-center pt-0 pb-2">
                        <div v-if="accept === true">
                            <v-img
                                :src="require('@/assets/orange_error.svg')"
                                contain
                                height="40"
                            />
                        </div>
                        <div v-else>
                            <v-img
                                :src="require('@/assets/red_error.svg')"
                                contain
                                height="40"
                            />
                        </div>
                    </v-col>
                    <v-col cols="12" md="12" class="mb-1 d-flex justify-center">
                        <div v-if="accept === true">
                            <div class="prompt-title-500">
                                {{ $t('message.qualifiedApplicants.acceptDialog.transfer') }}
                            </div>
                        </div>
                        <div v-else>
                            <div class="prompt-title-500">
                                {{ $t('message.qualifiedApplicants.transfer') }}
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="12" class="my-0 pt-0">
                        <div
                            class="
                                form-label-400
                                text-center
                                px-md-0 px-10
                                mb-2
                                d-flex
                                row
                                justify-center
                            "
                            id="step4-para"
                        >
                            <div>{{ $t('message.qualifiedApplicants.acceptDialog.head') }} {{transferNumber}} {{ $t('message.qualifiedApplicants.acceptDialog.case') }}</div>
                            <div>{{ $t('message.qualifiedApplicants.acceptDialog.tail') }}</div>
                        </div>
                    </v-col>
                </v-row>
                <v-row class="mx-2 d-flex">
                    <v-col
                        cols="12"
                        md="6"
                        class="
                            mb-0
                            pt-0
                            mb-md-1
                            pt-md-4
                            pb-md-4
                            order-12 order-md-1
                        "
                    >
                        <v-btn
                            class="prompt-title-page"
                            color="#FF9800"
                            height="40"
                            block
                            rounded
                            dark
                            @click="moveDialog = false"
                            outlined
                            style="
                                box-shadow: 0px 0px 20px rgba(255, 152, 0, 0.2);
                                font-size: 18px;
                            "
                            >{{ $t('message.qualifiedApplicants.dialog.cancel') }}</v-btn
                        >
                    </v-col>

                    <v-col
                        cols="12"
                        md="6"
                        class="
                            mb-0
                            pt-0
                            mb-md-1
                            pt-md-4
                            pb-md-4
                            order-1 order-md-12
                        "
                    >
                        <v-btn
                            class="prompt-title-page"
                            color="#FF544A"
                            height="40"
                            block
                            rounded
                            dark
                            @click="submitTransfer" 
                            style="
                                box-shadow: 0px 0px 20px rgba(255, 152, 0, 0.2);
                                font-size: 18px;
                            "
                            >{{ $t('message.qualifiedApplicants.confirm') }}</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data() {
        return {
            moveDialog: false,
            accept: false,
        };
    },
    props: {
        Bool: Boolean,
        transferNumber: Number
    },
    methods: {
        submitTransfer() {
            this.moveDialog = false;
            this.$emit("submitTransfer");
        },
    },
    watch: {
        // whenever question changes, this function will run
        Bool() {
            this.moveDialog = true;
        },
    },
};
</script>